var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("../assets/word.png")}})]),_c('div',[_c('span',{staticStyle:{"margin-right":"10px"}},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("备案号：闽ICP备2023000601号")])])])])
}]

export { render, staticRenderFns }